import { render, staticRenderFns } from "./printDashboard.vue?vue&type=template&id=3d581141&"
import script from "./printDashboard.vue?vue&type=script&lang=js&"
export * from "./printDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports